<template>
  <div class="mask" v-if="dataVal.flag">
    <div class="mask-content">
      <div class="mask-content-header">
        <div>新增任务</div>
        <div @click="handleRefund">
          <el-icon name="close" size="16"></el-icon>
        </div>
      </div>
      <div class="mask-content-body">
        <div class="mask-content-body-select">
          <div class="mask-content-body-select-title">
            选择活动<span>*</span>：
          </div>
          <div class="mask-content-body-select-input">
            <el-select
              v-model="taskData.activity_id"
              placeholder="请选择活动"
              popper-class="groupselsect"
              popper-append-to-body
            >
              <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="mask-content-body-select">
          <div class="mask-content-body-select-title">
            任务范围<span>*</span>：
          </div>
          <div class="mask-content-body-select-input">
            <el-cascader
              placeholder="请选择任务范围"
              clearable
              filterable
              v-model="role_ids"
              :collapse-tags="true"
              :options="roleList"
              :props="{
                multiple: true,
                value: 'id',
                label: 'name',
                children: 'child',
              }"
            ></el-cascader>
          </div>
        </div>
        <div class="mask-content-body-select">
          <div class="mask-content-body-select-title">
            任务目标<span>*</span>：
          </div>
          <div class="mask-content-body-select-input">
            <el-input
              v-model="taskData.targetcount"
              placeholder="请输入任务目标"
              type="number"
            ></el-input>
          </div>
        </div>
        <div class="mask-content-footer">
          <div @click="handleRefund">取消</div>
          <div @click="handleSubmit">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddGroup",
  props: ["dataVal"],
  data() {
    return {
      //表格列表
      list: [],
      role_ids: [],
      //会员身份
      roleList: [],
      taskData: {
        activity_id: "", //活动id
        role_ids: "", //任务角色范围
        targetcount: "", //目标数量
      },
      flag: false,
    };
  },
  mounted() {
    this.userRolelist();
    this.activityActivitylist();
  },
  methods: {
    async activityActivitylist() {
      let res = await this.$api.activityActivitylist({
        count: 99999999,
        page: 1,
      });
      if (res.code == 1) {
        this.list = res.data.list;
      }
    },
    //会员身份列表
    async userRolelist() {
      let res = await this.$api.userRolelist();
      if (res.code == 1) {
        res.data.forEach((item) => {
          if (item.child.length == 0) {
            item.child = null;
          }
        });
        this.roleList = res.data;
      }
    },
    //取消弹窗
    handleRefund() {
      let data = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("addTaskCall", data);
    },
    async handleSubmit() {
      if (this.flag) {
        return false;
      }
      this.flag = true;
      let res = await this.$api.activityTaskadd({
        activity_id: this.taskData.activity_id,
        role_ids: this.role_ids.length == 0 ? "" :this.role_ids.toString(),
        targetcount: this.taskData.targetcount,
      });
      if (res.code == 1) {
        this.flag = false;
        let data = {
          flag: false, //弹窗是否显示
          submitFlag: true, //是否调用接口
        };
        this.$emit("addTaskCall", data);
      }else {
        this.flag = false;
      }
    },
  },
  watch: {
    dataVal: {
      handler(val) {
        if (val.flag) {
            this.flag = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1999;

  .mask-content {
    width: 715px;
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
    position: fixed;

    .mask-content-header {
      width: 100%;
      min-height: 50px;
      background: #c12e30;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px;

      div {
        color: var(--Gray-White, #fff);
        font-size: 16px;
      }

      .el-icon-close {
        color: #fff;
      }
    }

    .mask-content-body {
      width: 100%;
      background-color: #fff;
      padding: 20px 20px 34px 20px;

      .mask-content-body-select {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .mask-content-body-select-title {
          width: 87px;
          color: #a6a6a6;
          font-size: 14px;
          display: flex;
          align-items: center;

          span {
            color: #c12e30;
          }
        }

        .mask-content-body-select-input {
          flex: 1;

          .el-select {
            width: 100%;
          }
        }
      }

      .mask-content-footer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 437px;

        div {
          width: 120px;
          height: 40px;
          color: rgba(0, 0, 0, 0.9);
          font-size: 14px;
          border-radius: 5px 0 0 5px;
          background: #edc2c3;
          @include flex-center(center, center);
          cursor: pointer;

          &:nth-child(2) {
            border-radius: 0 5px 5px 0;
            color: rgba(255, 255, 255, 0.9);
            background: #b30003;
          }
        }
      }
    }
  }
}
</style>